import Vue from "vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

Vue.use(VuePersianDatetimePicker, {
  name: "aironpax-date-picker",
  props: {
    autoSubmit: true,
    color: "#1D398D",
  },
});
